module.exports = __webpack_public_path__ + "imgs/BipoCann.093b78b3a475f8cf3f3747af7ea81973.png";